var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAddFriend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "o4nojp0sqa",
    d: "M9 9c2.071 0 3.75 1.679 3.75 3.75v1.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-1.5c0-1.243-1.007-2.25-2.25-2.25H3.75c-1.243 0-2.25 1.007-2.25 2.25v1.5c0 .414-.336.75-.75.75S0 14.664 0 14.25v-1.5C0 10.679 1.679 9 3.75 9H9zM6.75 0c2.071 0 3.75 1.679 3.75 3.75 0 2.071-1.679 3.75-3.75 3.75C4.679 7.5 3 5.821 3 3.75 3 1.679 4.679 0 6.75 0zm0 1.5C5.507 1.5 4.5 2.507 4.5 3.75S5.507 6 6.75 6 9 4.993 9 3.75 7.993 1.5 6.75 1.5zM15 3.75c.414 0 .75.336.75.75V6h1.5c.414 0 .75.336.75.75s-.336.75-.75.75h-1.5V9c0 .414-.336.75-.75.75s-.75-.336-.75-.75V7.5h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5V4.5c0-.414.336-.75.75-.75z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-520 -274) translate(40 274) translate(480) translate(4 5)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "current",
    fillRule: "nonzero",
    xlinkHref: "#o4nojp0sqa"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddFriend);
export default __webpack_public_path__ + "static/media/iconAddFriend.63f97a45.svg";
export { ForwardRef as ReactComponent };